import { RESPONSE_REQUEST } from './actionsTypes';

export const sendResponse = (status, message) => {
  return { type: RESPONSE_REQUEST, payload: { status, message, date: new Date(), loading: false } }
};



// WEBPACK FOOTER //
// ./src/actions/request.js